import React, { useState, useCallback } from "react";
import { t } from "i18next";
import { useDispatch } from "react-redux";
import { display } from "redux-react/reducers/snackBarReducer";
import { ATTACHEMENTS } from "../../../../../../contants";
import { deleteFileFromPath } from "../../../../../../helpers/s3";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import MDButton from "components/Basics/MDButton";
import CloudUpload from "@mui/icons-material/CloudUpload";
import FileDisplay from "./FileDisplay";
import DialogUploadFile from "../../../../../../components/Custom/DialogUploadFile";
import { getAcceptedFile } from "./acceptedFile";

const UploadFile = ({ onChangeTypologyInput, codeLanguage, attachments = [], acceptedFile }) => {
	const dispatch = useDispatch();
	const [dialogOpen, setDialogOpen] = useState(false);
	const [deleting, setDeleting] = useState(false);

	const handleDelete = useCallback(
		async fileState => {
			setDeleting(true);
			try {
				const deleteResponse = await deleteFileFromPath({
					key: fileState.key,
					path: fileState.path,
					fileName: fileState.name
				});
				if (!deleteResponse?.success) {
					throw new Error("Failed to delete file from S3");
				}
				dispatch(display({ type: "success", message: t("SOURCES.FILES.deleteSuccess") }));

				const updatedAttachments = attachments.filter(file => {
					return file.key !== fileState.key;
				});

				onChangeTypologyInput(codeLanguage, ATTACHEMENTS, updatedAttachments);
			} catch (error) {
				dispatch(display({ type: "error", message: t("SOURCES.FILES.deleteError") }));
			} finally {
				setDeleting(false);
			}
		},
		[dispatch, onChangeTypologyInput, codeLanguage, attachments]
	);

	const handleCloseUploadFileDialog = () => {
		setDialogOpen(false);
	};

	return (
		<Box>
			<Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 2 }}>
				<MDButton
					variant="contained"
					color="info"
					startIcon={<CloudUpload />}
					onClick={() => setDialogOpen(true)}
					sx={{ borderRadius: "8px", padding: "8px 16px", textTransform: "none" }}
					disabled={deleting}
				>
					{t("SOURCES.FILES.uploadButtonLabel")}
				</MDButton>
			</Box>

			{Array.isArray(attachments) && attachments.length > 0 ? (
				attachments.map((it, index) => (
					<FileDisplay
						key={it.key || `file-${index}`}
						fileState={it}
						onDelete={handleDelete}
						onUploadClick={() => setDialogOpen(true)}
						disabled={deleting}
					/>
				))
			) : (
				<Box sx={{ mt: 2 }}>
					<Typography variant="body2" color="text.secondary">
						{t("SOURCES.FILES.noAttachments")}
					</Typography>
				</Box>
			)}

			{dialogOpen && (
				<DialogUploadFile
					onClose={handleCloseUploadFileDialog}
					onChangeTypologyInput={onChangeTypologyInput}
					codeLanguage={codeLanguage}
					attachments={attachments}
					acceptFile={getAcceptedFile?.(acceptedFile)}
				/>
			)}
		</Box>
	);
};

export default UploadFile;
